export default function () {
	$('.scroll-show').each(function(i, elm) {

		const $wh = $(window).height();
		const $st = $(window).scrollTop();
		const $sb = $st + $wh * .75;

		if ($(elm).is('.is-show')) {
			return true;
		}

		const $pos = $(elm).offset().top;
		if ($pos < $sb) {
			$(elm).addClass('is-show');
		}
		return;
	});
}
